export default __webpack_public_path__ + "static/media/Tutorial-Step-2.2.12b4891f.jpg";